import { render } from "./CargoItemRegistriesPage.vue?vue&type=template&id=39dccaa4&scoped=true"
import script from "./CargoItemRegistriesPage.vue?vue&type=script&lang=js"
export * from "./CargoItemRegistriesPage.vue?vue&type=script&lang=js"

import "./CargoItemRegistriesPage.vue?vue&type=style&index=0&id=39dccaa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39dccaa4"]])

export default __exports__